// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: uOdAuk8zpe
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicReturnCityOverviewButton.module.css"; // plasmic-import: uOdAuk8zpe/css
import BackSvgrepoComSvgIcon from "./icons/PlasmicIcon__BackSvgrepoComSvg"; // plasmic-import: wRFugbPwDI0o/icon

createPlasmicElementProxy;

export const PlasmicReturnCityOverviewButton__VariantProps = new Array();

export const PlasmicReturnCityOverviewButton__ArgProps = new Array();

const $$ = {};

function PlasmicReturnCityOverviewButton__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <PlasmicLink__
        data-plasmic-name={"link"}
        data-plasmic-override={overrides.link}
        className={classNames(projectcss.all, projectcss.a, sty.link)}
        href={`/city-page`}
        platform={"react"}
      >
        <div className={classNames(projectcss.all, sty.freeBox__d1F)}>
          <BackSvgrepoComSvgIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames(projectcss.all, sty.svg)}
            role={"img"}
          />
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__y80RG)}>
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"Return to city overview"}
          </div>
        </div>
      </PlasmicLink__>
    </button>
  );
}

const PlasmicDescendants = {
  root: ["root", "link", "svg", "text"],
  link: ["link", "svg", "text"],
  svg: ["svg"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicReturnCityOverviewButton__ArgProps,
          internalVariantPropNames:
            PlasmicReturnCityOverviewButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicReturnCityOverviewButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicReturnCityOverviewButton";
  } else {
    func.displayName = `PlasmicReturnCityOverviewButton.${nodeName}`;
  }
  return func;
}

export const PlasmicReturnCityOverviewButton = Object.assign(
  // Top-level PlasmicReturnCityOverviewButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    link: makeNodeComponent("link"),
    svg: makeNodeComponent("svg"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicReturnCityOverviewButton
    internalVariantProps: PlasmicReturnCityOverviewButton__VariantProps,
    internalArgProps: PlasmicReturnCityOverviewButton__ArgProps
  }
);

export default PlasmicReturnCityOverviewButton;
/* prettier-ignore-end */
